import { Box } from '@mui/material';
import { backgroundConfigAtom, sourceConfigAtom } from '_state/signature';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
// import BackgroundConfigCard from './core/components/BackgroundConfigCard';
// import SourceConfigCard from './core/components/SourceConfigCard';
import ViewerCard from './core/components/ViewerCard';
import { PostProcessingConfig } from './core/helpers/postProcessingHelper';
import { SegmentationConfig } from './core/helpers/segmentationHelper';
import useBodyPix from './core/hooks/useBodyPix';
import useTFLite from './core/hooks/useTFLite';

const MeetingBackground = () => {
  // const [sourceConfig, setSourceConfig] = useState<SourceConfig>({
  //   type: 'image',
  //   // url: sourceImageUrls[0],
  //   url: '',
  // });

  const sourceConfig = useRecoilValue(sourceConfigAtom);
  const backgroundConfig = useRecoilValue(backgroundConfigAtom);
  // const [customBackgrounds, setCustomBackgrounds] = useRecoilState(customBackgroundsAtom);

  // const [customBackgrounds, setCustomBackgrounds] = useState<CustomBackgroundType>([]);

  // const [backgroundConfig, setBackgroundConfig] = useState<BackgroundConfig>({
  //   type: 'image',
  //   url: backgroundImageUrls[0],
  // });
  const [segmentationConfig, setSegmentationConfig] = useState<SegmentationConfig>({
    model: 'meet',
    backend: 'wasm',
    inputResolution: '160x96',
    pipeline: 'webgl2',
    targetFps: 65, // 60 introduces fps drop and unstable fps on Chrome
    deferInputResizing: true,
  });
  const [postProcessingConfig] = useState<PostProcessingConfig>({
    smoothSegmentationMask: true,
    jointBilateralFilter: { sigmaSpace: 6, sigmaColor: 0.1 },
    coverage: [0.5, 0.75],
    lightWrapping: 0.3,
    blendMode: 'screen',
  });
  const bodyPix = useBodyPix();
  const { tflite, isSIMDSupported } = useTFLite(segmentationConfig);

  useEffect(() => {
    setSegmentationConfig(previousSegmentationConfig => {
      if (previousSegmentationConfig.backend === 'wasm' && isSIMDSupported) {
        return { ...previousSegmentationConfig, backend: 'wasmSimd' };
      } else {
        return previousSegmentationConfig;
      }
    });
  }, [isSIMDSupported]);

  // const onUpload = (
  //   e: React.ChangeEvent<HTMLInputElement> | { target: { name: string; files: FileList } },
  // ) => {
  //   if (e.target.files && e.target.files.length > 0) {
  //     // const name = e.target.name;
  //     const value = e.target.files[0];
  //     setBackgroundConfig({ type: 'image', url: value });
  //     setCustomBackgrounds([value, ...customBackgrounds]);
  //   }
  // };

  // const onClickDelete = (index: number) => {
  //   const customBackgroundsCopy = [...customBackgrounds];
  //   if (index > -1) {
  //     customBackgroundsCopy.splice(index, 1);
  //   }
  //   setCustomBackgrounds(customBackgroundsCopy);
  // };
  return (
    <Box
      sx={theme => ({
        display: 'grid',

        // [theme.breakpoints.up('xs')]: {
        //   margin: theme.spacing(1),
        //   gap: theme.spacing(1),
        //   gridTemplateColumns: '1fr',
        // },

        // [theme.breakpoints.up('md')]: {
        //   margin: theme.spacing(2),
        //   gap: theme.spacing(2),
        //   gridTemplateColumns: 'repeat(2, 1fr)',
        // },

        // [theme.breakpoints.up('lg')]: {
        //   gridTemplateColumns: 'repeat(3, 1fr)',
        // },
        // margin: theme.spacing(1),
        gap: theme.spacing(1),
        gridTemplateColumns: '1fr',
      })}
    >
      <ViewerCard
        sourceConfig={sourceConfig}
        backgroundConfig={backgroundConfig}
        segmentationConfig={segmentationConfig}
        postProcessingConfig={postProcessingConfig}
        bodyPix={bodyPix}
        tflite={tflite}
      />
      {/* <Box
        display={'flex'}
        justifyContent="center"
        alignItems={'flex-start'}
        gap={2}
        mt={2}
        sx={{
          '& .MuiPaper-root.MuiPaper-elevation': {
            border: '1px solid #ced4da',
            boxShadow: 'none',
          },
        }}
      >
        <SourceConfigCard config={sourceConfig} onChange={setSourceConfig} />

        <BackgroundConfigCard
          config={backgroundConfig}
          onChange={setBackgroundConfig}
          onUpload={onUpload}
          customBackgrounds={customBackgrounds}
          onClickDelete={onClickDelete}
        />
      </Box> */}
    </Box>
  );
};

export default MeetingBackground;
